export const icons = {
  1: require('@globalImg/taobao.png'),
  2: require('@globalImg/Tmall.png'),
  4: require('@globalImg/together.png'),
  8: require('@globalImg/new.png')
}
